import { useTreatments } from '@splitsoftware/splitio-react';

/**
 * Evaluates a set of beta flags for the given traffic key.
 * A flag is enabled only when its treatment is exactly 'on'.
 */
export const useBetaAccessFlag = (splitKey: string, flagNames: string[]) => {
  const { treatments, isReady, hasTimedout } = useTreatments({
    names: flagNames,
    splitKey,
  });

  const enabledFlags = flagNames.filter(
    (flag) => isReady && treatments?.[flag] === 'on',
  );
  const isFlagLoading = flagNames.length > 0 && !isReady && !hasTimedout;

  const isFlagEnabled = (flag?: string) =>
    flag === undefined || enabledFlags.includes(flag);

  return { enabledFlags, isFlagEnabled, isFlagLoading, isReady, hasTimedout };
};
